module.exports = __webpack_public_path__ + "img/1f_r_tonya.a6088fa0.jpg";